import { RotateCcw, Clock } from "lucide-react";
import { Badge } from "@/components/ui";
import { formatCurrency, cn } from "@/lib/utils";
import { deriveRefundState } from "../lib/refund-state";
import type { Order } from "@/types";

interface RefundBadgeProps {
  order: Order;
  className?: string;
}

export function RefundBadge({ order, className }: RefundBadgeProps) {
  const state = deriveRefundState(order);
  if (state.kind === "none") return null;

  if (state.kind === "full") {
    return (
      <Badge
        variant="outline"
        className={cn("gap-1 border-red-300 bg-red-50 text-red-700", className)}
      >
        <RotateCcw className="h-3 w-3" />
        Refunded
      </Badge>
    );
  }

  if (state.kind === "partial") {
    return (
      <Badge
        variant="outline"
        className={cn(
          "gap-1 border-orange-300 bg-orange-50 text-orange-700",
          className,
        )}
      >
        <RotateCcw className="h-3 w-3" />
        Partial refund · {formatCurrency(state.refundedAmount)}
      </Badge>
    );
  }

  return (
    <Badge
      variant="outline"
      className={cn(
        "gap-1 border-amber-300 bg-amber-50 text-amber-700",
        className,
      )}
    >
      <Clock className="h-3 w-3" />
      Refund pending
    </Badge>
  );
}
